var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCartIcon = function SvgCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#F7F5E1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.658 19.365h-12.94a4.196 4.196 0 0 1-4.121-3.443L4.092 1.104H.702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.701 5.104H25.05l-1.252 6.052c-.47 2.296-2.452 3.966-4.748 4.122l-12.522.783m1.999 8.695a1.826 1.826 0 1 0 0-3.652 1.826 1.826 0 0 0 0 3.652Zm13 0a1.826 1.826 0 1 0 0-3.652 1.826 1.826 0 0 0 0 3.652Z"
  }))));
};
export default SvgCartIcon;